export enum OrderTypes {
    ASC = "asc",
    DESC = "desc",
}
